import React from 'react';
import { Mail, Phone, MessageSquare, Video, Calendar } from 'lucide-react';

// ContactButton Component - can be used anywhere
const ContactButton = ({
  type = 'phone',  // Default contact type
  text = 'Contact Us', // Default text
  action = null,   // Custom action function
  variant = 'primary', // Bootstrap button variant
  size = 'md',     // Button size
  className = '',  // Additional classes
  showIcon = true, // Whether to show the icon
  iconSize = 20,   // Icon size
  isMobile = false, // Whether this is for mobile view
  openInNewTab = false, // Whether to open in a new tab
  contactInfo = {  // Default contact info
    phone: '90634 27464',
    email: 'sales@klmpack.com',
    whatsapp: '90634 27464',
    videoCall: 'https://meet.google.com',
    schedule: 'https://calendly.com/example'
  }
}) => {
  // Contact type configurations
  const contactTypes = {
    phone: {
      icon: <Phone size={iconSize} />,
      defaultAction: () => {
        const phoneNumber = contactInfo.phone.replace(/\s+/g, '');
        // For phone calls, use location.href to open in same tab without "_blank"
        window.location.href = `tel:+${phoneNumber}`;
      },
      url: `tel:+${contactInfo.phone.replace(/\s+/g, '')}`,
      defaultText: contactInfo.phone
    },
    email: {
      icon: <Mail size={iconSize} />,
      defaultAction: () => {
        // For email, use location.href to open in same tab
        window.location.href = `mailto:${contactInfo.email}`;
      },
      url: `mailto:${contactInfo.email}`,
      defaultText: contactInfo.email
    },
    whatsapp: {
      icon: <MessageSquare size={iconSize} />,
      defaultAction: () => {
        const whatsappNumber = contactInfo.whatsapp.replace(/\s+/g, '');
        // WhatsApp is typically an external app, may still open in new tab
        window.location.href = `https://wa.me/${whatsappNumber}`;
      },
      url: `https://wa.me/${contactInfo.whatsapp.replace(/\s+/g, '')}`,
      defaultText: 'WhatsApp'
    },
    videoCall: {
      icon: <Video size={iconSize} />,
      defaultAction: () => {
        if (openInNewTab) {
          window.open(contactInfo.videoCall, '_blank');
        } else {
          window.location.href = contactInfo.videoCall;
        }
      },
      url: contactInfo.videoCall,
      defaultText: 'Video Call'
    },
    schedule: {
      icon: <Calendar size={iconSize} />,
      defaultAction: () => {
        if (openInNewTab) {
          window.open(contactInfo.schedule, '_blank');
        } else {
          window.location.href = contactInfo.schedule;
        }
      },
      url: contactInfo.schedule,
      defaultText: 'Schedule'
    }
  };

  // Get configuration for selected type
  const selectedType = contactTypes[type] || contactTypes.phone;
  
  // Use the provided text or default text for the selected type
  const buttonText = text === 'Contact Us' ? selectedType.defaultText : text;
  
  // Use the provided action or default action for the selected type
  const handleClick = (e) => {
    e.preventDefault(); // Prevent default button behavior
    if (action) {
      action();
    } else {
      selectedType.defaultAction();
    }
  };

  // For mobile, use d-inline-flex instead of d-flex
  const displayClass = isMobile ? 'd-inline-flex' : 'd-flex';

  return (
    <button 
      className={`btn btn-${variant} ${size === 'lg' ? 'btn-lg' : size === 'sm' ? 'btn-sm' : ''} ${displayClass} align-items-center gap-2 ${className}`}
      onClick={handleClick}
    >
      {showIcon && selectedType.icon}
      <span className="fw-medium">{buttonText}</span>
    </button>
  );
};

export default ContactButton;